export const preJoinLabels = {
  joinLabel: 'Войти',
  micLabel: 'Микрофон',
  camLabel: 'Камера',
  userLabel: 'Имя',
} as const;

export const homeLabels = {
  startMeeting: 'Начать встречу',
  startingMeeting: 'Создаём комнату…',
  roomPassword: 'Пароль комнаты',
  roomPasswordPlaceholder: 'Оставьте пустым для открытой комнаты',
  roomPasswordHint: 'Если указан пароль, комната, резюме и API будут доступны только с ним.',
} as const;

export const roomJoinLabels = {
  roomPassword: 'Пароль комнаты',
  roomPasswordRequired: 'Для этой комнаты нужен пароль',
  invalidRoomPassword: 'Неверный пароль комнаты',
} as const;
